import loadFiles from "../helpers/load-files";

export default function initCmsComponents(switcher, onEvent) {
    cmsActionPanel(switcher, onEvent);
    disableLinksUnderCms();
    adminPanelDisplayButton();
}

function cmsActionPanel(switcher, onEvent) {
    // надо закрывать все всплывашки при любом нажатии, кроме кнопки, которая их показывает
    onEvent("click", "html", function (e) {
        const panelBtn = e.target.closest(".cms-panel-btn");
        const panels = document.querySelectorAll(
            ".cms-action-panel.switcher-enable"
        );
        for (const panel of panels) {
            if (panelBtn && panel.contains(panelBtn)) {
                continue;
            }
            const name = panel.dataset.switcherContent;
            switcher.executeAction(name, "disable");
        }
    });
}

function disableLinksUnderCms() {
    const panels = document.querySelectorAll(".cms-action-panel");

    for (let panel of panels) {
        let linkPanel = $(panel).parents("a");
        if (linkPanel.length == 0) {
            continue;
        }

        linkPanel.on("click", function (event) {
            const target = event.target;
            let className = target.className;

            if (className.includes("cms-")) {
                event.preventDefault();
            }
        });
    }
}

function adminPanelDisplayButton() {
    const adminPanel = document.querySelector("#admin-panel");
    if (!adminPanel) {
        return;
    }

    const displayButton = adminPanel.querySelector(".display-button");
    if (!displayButton) {
        return;
    }

    const closeAdminPanel = $.cookie("close-admin-panel");
    if (!closeAdminPanel) {
        displayButton.classList.remove("closed");
        displayButton.classList.add("opened");

        adminPanel.classList.remove("hidden");
    }

    displayButton.addEventListener("click", function (ev) {
        if (displayButton.classList.contains("closed")) {
            displayButton.classList.remove("closed");
            displayButton.classList.add("opened");

            adminPanel.classList.remove("hidden");
            return;
        }

        var date = new Date();
        date.setDate(date.getDate() + 1);
        document.cookie = [
            "close-admin-panel=1",
            "; expires=",
            date.toUTCString(),
            "; path=",
            "/",
            "; SameSite=",
            "Lax"
        ].join("");

        displayButton.classList.remove("opened");
        displayButton.classList.add("closed");

        adminPanel.classList.add("hidden");
    });
}
